import React, {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { CSVReader } from 'react-papaparse';
import orderHelper from '../../helpers/orders';
import orderHelpers from '../../helpers/orders';
import Alert from '@mui/material/Alert';
import fileHelpers from '../../helpers/files';

const buttonRef = React.createRef();

function AmazonBulkUpload(props) {

  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [locationErrors, setLocationErrors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [orders, setOrders] = useState(null);
  const [uploads, setUploads] = useState([]);
  const [selected, setSelected] = useState([]);

    const handleOpenDialog = (e) => {
      // Note that the ref is set async, so it might be null at some point
      if (buttonRef.current) {
        buttonRef.current.open(e);
      }
    };

    const handleOnFileLoad = (data, file) => {
      console.log('---------------------------');
      setFile(file);
      setSuccess(false);
      const orders = orderHelper.formatOrders(data);
      setOrders(orders);
      console.log('---------------------------');
    };
  
    const handleOnError = (err, file, inputElem, reason) => {
      console.log('---------------------------');
      console.log(err);
      console.log('---------------------------');
      setError(`Error Uploading Order File: ${err}`)
    };

    const uploadFile = async () => {
      props.setLoading(true);
      setError("")
      setSuccess(false)
      const body = {
        orders: orders,
        user: props.user.attributes.name, 
        company_name: props.company,
        filename: file.name
      }
      let upload = await orderHelpers.uploadAmazonBulkOrders(props.company, body, props.token);
      if(upload === true) {
        setSuccess(true);
      } else if (upload && upload.invalid_locations && upload.invalid_locations.length > 0) {
        setLocationErrors(
          upload.invalid_locations.map((item) => `${item.Customer} - ${item.Location}`)
        );
      } else {
        setError(`Error: ${upload && upload.message ? upload.message : JSON.stringify(upload)}`);
      }
      props.setLoading(false);
    }
  
    const handleRemoveFile = (e) => {
      // Note that the ref is set async, so it might be null at some point
      if (buttonRef.current) {
        buttonRef.current.removeFile(e);
        setFile(null);
        setOrders(null);
      }
    };

    const deleteUpload = async() => {
      if(window.confirm(`Delete Upload #${selected[0]}?`)) {
        props.setLoading(true);
        await orderHelpers.deleteUpload(props.company, {upload_id:selected[0]}, props.token)
        props.setLoading(false);
      }
    }



        return (
            <Box display="flex" flexDirection="column">
            <Box className={props.isMobile ? "mobile-box" : "desktop-box"}>
              {error !== "" ? (
                <Alert
                  style={{ marginTop: "24px", color: "white", width: "80%" }}
                  severity="error"
                  className={`${props.company} ${props.warehouse} error`}
                >
                  {error}
                </Alert>
              ) : null}

              {locationErrors.length > 0 ? (
                <Alert
                  style={{ marginTop: "24px", color: "white", width: "80%" }}
                  severity="error"
                  className={`${props.company} ${props.warehouse} error`}
                >
                  <div>MISSING LOCATIONS:</div>
                  {locationErrors.map((line, i) => (
                    <div key={i}>{line}</div>
                  ))}
                </Alert>
              ) : null}

              <h1>Amazon Upload</h1>

              <CSVReader
                ref={buttonRef}
                onFileLoad={handleOnFileLoad}
                onError={handleOnError}
                noClick
                noDrag
                config={{
                  header: true,
                  skipEmptyLines: true
                }}
                style={{}}
              >
                {({ file_obj }) => (
                  <aside>
                    <Box display="flex" flexDirection="column" gap={2}>
                    <Button
                      variant="contained"
                      size="medium"
                      onClick={handleOpenDialog}
                      className={`${props.company} ${props.warehouse} secondary`}
                      sx={{ alignSelf: "flex-start" }}
                    >
                      Browse file
                    </Button>

                    {file ? (
                      <div>
                        Selected file: <strong>{file.name}</strong>
                      </div>
                    ) : null}

                      <div>{file_obj && file_obj.name}</div>

                      {file !== null ? (
                        <Box display="flex" gap={2} mt={1}>
                          <Button
                            variant="contained"
                            onClick={uploadFile}
                            disabled={props.isLoading}
                            className={`${props.company} ${props.warehouse} secondary`}
                          >
                            Upload
                          </Button>

                          <Button
                            variant="contained"
                            onClick={handleRemoveFile}
                            disabled={props.isLoading}
                            className={`${props.company} ${props.warehouse} tertiary`}
                          >
                            Remove
                          </Button>
                        </Box>
                      ) : null}
                    </Box>
                  </aside>
                )}
              </CSVReader>

              {success ? <Alert severity="success">Upload Successful!</Alert> : null}

              {selected.length === 1 ? (
                <Box
                  style={{
                    marginTop: "50px",
                    border: "1px solid black",
                    width: "60%",
                    padding: "20px",
                    paddingTop: "0"
                  }}
                >
                  <h3>Upload ID: {selected[0]}</h3>
                  <Box display="flex" gap={2}>
                    {props.scopes?.includes("admin") ? (
                      <Button onClick={deleteUpload} color="error" variant="contained">
                        Delete
                      </Button>
                    ) : null}
                  </Box>
                </Box>
              ) : null}
            </Box>
          </Box>
        );
    
}

export default AmazonBulkUpload